// extracted by mini-css-extract-plugin
export var button = "_1b-0";
export var buttonContent = "_1b-e";
export var buttonGroup = "_1b-c";
export var dontRestrainIconWidth = "_1b-a";
export var dropdownButton = "_1b-b";
export var iconContainer = "_1b-9";
export var lg = "_1b-4";
export var md = "_1b-3";
export var pending = "_1b-f";
export var sm = "_1b-2";
export var spinner = "_1b-d";
export var squared = "_1b-8";
export var wrapText = "_1b-g";
export var xl = "_1b-5";
export var xs = "_1b-1";
export var xxl = "_1b-6";
export var xxxl = "_1b-7";